import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "../../data/content";
import { Reveal, scrollToId } from "../../lib/motion";

const Item = ({ faq, open, onToggle, idx }) => (
  <div className="border-b border-sage/25" data-testid="faq-item">
    <button
      onClick={onToggle}
      data-testid={`faq-toggle-${idx}`}
      className="w-full flex items-center justify-between gap-6 py-7 text-left group"
      aria-expanded={open}
    >
      <span className="font-serif text-xl lg:text-2xl text-ink pr-4">{faq.q}</span>
      <span className={`shrink-0 flex h-9 w-9 items-center justify-center rounded-full border border-sage-light transition-all duration-300 ${open ? "bg-sage-dark border-sage-dark rotate-45" : "group-hover:bg-cream-100"}`}>
        <Plus size={17} className={open ? "text-cream" : "text-sage-dark"} strokeWidth={1.8} />
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <p className="pb-7 pr-14 text-[1.02rem] text-ink-soft leading-relaxed">{faq.a}</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faqs" className="py-24 lg:py-36 bg-cream" aria-labelledby="faq-heading">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal><p className="overline text-sage-dark mb-5">Questions</p></Reveal>
            <Reveal delay={0.05}>
              <h2 id="faq-heading" className="font-serif text-4xl sm:text-5xl text-ink leading-[1.05] tracking-tight">
                It's natural to wonder.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-ink-soft leading-relaxed">
                A few of the things people often ask before getting in touch. If your question isn't
                here, please just ask.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <button
                onClick={() => scrollToId("contact")}
                data-testid="faq-contact-btn"
                className="mt-8 rounded-full bg-sage-dark hover:bg-sage-deep text-cream px-6 py-3.5 text-sm font-medium tracking-wide transition-all duration-300 active:scale-[0.98]"
              >
                Ask a question
              </button>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          {FAQS.map((faq, idx) => (
            <Item
              key={idx}
              faq={faq}
              idx={idx}
              open={open === idx}
              onToggle={() => setOpen(open === idx ? -1 : idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
